"use strict";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function get() {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DynamicMenu = exports.ApplicationMenu = exports.MenuItem = exports.dockPositionToJSON = exports.dockPositionFromJSON = exports.DockPosition = void 0;
var _m0 = __importStar(require("protobufjs/minimal"));
var param_1 = require("./param");
var template_host_1 = require("./template-host");
var DockPosition;
(function (DockPosition) {
  DockPosition[DockPosition["APP"] = 0] = "APP";
  DockPosition[DockPosition["SUB"] = 1] = "SUB";
  DockPosition[DockPosition["SIDE"] = 2] = "SIDE";
  DockPosition[DockPosition["HOME"] = 3] = "HOME";
  DockPosition[DockPosition["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(DockPosition = exports.DockPosition || (exports.DockPosition = {}));
function dockPositionFromJSON(object) {
  switch (object) {
    case 0:
    case "APP":
      return DockPosition.APP;
    case 1:
    case "SUB":
      return DockPosition.SUB;
    case 2:
    case "SIDE":
      return DockPosition.SIDE;
    case 3:
    case "HOME":
      return DockPosition.HOME;
    case -1:
    case "UNRECOGNIZED":
    default:
      return DockPosition.UNRECOGNIZED;
  }
}
exports.dockPositionFromJSON = dockPositionFromJSON;
function dockPositionToJSON(object) {
  switch (object) {
    case DockPosition.APP:
      return "APP";
    case DockPosition.SUB:
      return "SUB";
    case DockPosition.SIDE:
      return "SIDE";
    case DockPosition.HOME:
      return "HOME";
    case DockPosition.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}
exports.dockPositionToJSON = dockPositionToJSON;
function createBaseMenuItem() {
  return {
    label: "",
    templateId: "",
    url: "",
    position: 0,
    host: 0,
    menuItems: [],
    params: [],
    labelTranslationKey: "",
    translatedLabel: "",
    isDifferentlyStyled: false
  };
}
exports.MenuItem = {
  encode: function encode(message) {
    var writer = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _m0.Writer.create();
    if (message.label !== undefined && message.label !== "") {
      writer.uint32(10).string(message.label);
    }
    if (message.templateId !== undefined && message.templateId !== "") {
      writer.uint32(18).string(message.templateId);
    }
    if (message.url !== undefined && message.url !== "") {
      writer.uint32(26).string(message.url);
    }
    if (message.position !== undefined && message.position !== 0) {
      writer.uint32(32).int32(message.position);
    }
    if (message.host !== undefined && message.host !== 0) {
      writer.uint32(40).int32(message.host);
    }
    if (message.menuItems !== undefined && message.menuItems.length !== 0) {
      var _iterator = _createForOfIteratorHelper(message.menuItems),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var v = _step.value;
          exports.MenuItem.encode(v, writer.uint32(50).fork()).ldelim();
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
    if (message.params !== undefined && message.params.length !== 0) {
      var _iterator2 = _createForOfIteratorHelper(message.params),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var _v = _step2.value;
          param_1.Param.encode(_v, writer.uint32(58).fork()).ldelim();
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
    }
    if (message.labelTranslationKey !== undefined && message.labelTranslationKey !== "") {
      writer.uint32(66).string(message.labelTranslationKey);
    }
    if (message.translatedLabel !== undefined && message.translatedLabel !== "") {
      writer.uint32(74).string(message.translatedLabel);
    }
    if (message.isDifferentlyStyled === true) {
      writer.uint32(80).bool(message.isDifferentlyStyled);
    }
    return writer;
  },
  decode: function decode(input, length) {
    var reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    var end = length === undefined ? reader.len : reader.pos + length;
    var message = createBaseMenuItem();
    while (reader.pos < end) {
      var tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.label = reader.string();
          break;
        case 2:
          message.templateId = reader.string();
          break;
        case 3:
          message.url = reader.string();
          break;
        case 4:
          message.position = reader.int32();
          break;
        case 5:
          message.host = reader.int32();
          break;
        case 6:
          message.menuItems.push(exports.MenuItem.decode(reader, reader.uint32()));
          break;
        case 7:
          message.params.push(param_1.Param.decode(reader, reader.uint32()));
          break;
        case 8:
          message.labelTranslationKey = reader.string();
          break;
        case 9:
          message.translatedLabel = reader.string();
          break;
        case 10:
          message.isDifferentlyStyled = reader.bool();
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },
  fromJSON: function fromJSON(object) {
    return {
      label: isSet(object.label) ? String(object.label) : "",
      templateId: isSet(object.templateId) ? String(object.templateId) : "",
      url: isSet(object.url) ? String(object.url) : "",
      position: isSet(object.position) ? dockPositionFromJSON(object.position) : 0,
      host: isSet(object.host) ? (0, template_host_1.templateHostFromJSON)(object.host) : 0,
      menuItems: Array.isArray(object === null || object === void 0 ? void 0 : object.menuItems) ? object.menuItems.map(function (e) {
        return exports.MenuItem.fromJSON(e);
      }) : [],
      params: Array.isArray(object === null || object === void 0 ? void 0 : object.params) ? object.params.map(function (e) {
        return param_1.Param.fromJSON(e);
      }) : [],
      labelTranslationKey: isSet(object.labelTranslationKey) ? String(object.labelTranslationKey) : "",
      translatedLabel: isSet(object.translatedLabel) ? String(object.translatedLabel) : "",
      isDifferentlyStyled: isSet(object.isDifferentlyStyled) ? Boolean(object.isDifferentlyStyled) : false
    };
  },
  toJSON: function toJSON(message) {
    var obj = {};
    message.label !== undefined && (obj.label = message.label);
    message.templateId !== undefined && (obj.templateId = message.templateId);
    message.url !== undefined && (obj.url = message.url);
    message.position !== undefined && (obj.position = dockPositionToJSON(message.position));
    message.host !== undefined && (obj.host = (0, template_host_1.templateHostToJSON)(message.host));
    if (message.menuItems) {
      obj.menuItems = message.menuItems.map(function (e) {
        return e ? exports.MenuItem.toJSON(e) : undefined;
      });
    } else {
      obj.menuItems = [];
    }
    if (message.params) {
      obj.params = message.params.map(function (e) {
        return e ? param_1.Param.toJSON(e) : undefined;
      });
    } else {
      obj.params = [];
    }
    message.labelTranslationKey !== undefined && (obj.labelTranslationKey = message.labelTranslationKey);
    message.translatedLabel !== undefined && (obj.translatedLabel = message.translatedLabel);
    message.isDifferentlyStyled !== undefined && (obj.isDifferentlyStyled = message.isDifferentlyStyled);
    return obj;
  },
  create: function create(base) {
    return exports.MenuItem.fromPartial(base !== null && base !== void 0 ? base : {});
  },
  fromPartial: function fromPartial(object) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
    var message = createBaseMenuItem();
    message.label = (_a = object.label) !== null && _a !== void 0 ? _a : "";
    message.templateId = (_b = object.templateId) !== null && _b !== void 0 ? _b : "";
    message.url = (_c = object.url) !== null && _c !== void 0 ? _c : "";
    message.position = (_d = object.position) !== null && _d !== void 0 ? _d : 0;
    message.host = (_e = object.host) !== null && _e !== void 0 ? _e : 0;
    message.menuItems = ((_f = object.menuItems) === null || _f === void 0 ? void 0 : _f.map(function (e) {
      return exports.MenuItem.fromPartial(e);
    })) || [];
    message.params = ((_g = object.params) === null || _g === void 0 ? void 0 : _g.map(function (e) {
      return param_1.Param.fromPartial(e);
    })) || [];
    message.labelTranslationKey = (_h = object.labelTranslationKey) !== null && _h !== void 0 ? _h : "";
    message.translatedLabel = (_j = object.translatedLabel) !== null && _j !== void 0 ? _j : "";
    message.isDifferentlyStyled = (_k = object.isDifferentlyStyled) !== null && _k !== void 0 ? _k : false;
    return message;
  }
};
function createBaseApplicationMenu() {
  return {
    appId: "",
    menuItems: []
  };
}
exports.ApplicationMenu = {
  encode: function encode(message) {
    var writer = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _m0.Writer.create();
    if (message.appId !== undefined && message.appId !== "") {
      writer.uint32(10).string(message.appId);
    }
    if (message.menuItems !== undefined && message.menuItems.length !== 0) {
      var _iterator3 = _createForOfIteratorHelper(message.menuItems),
        _step3;
      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var v = _step3.value;
          exports.MenuItem.encode(v, writer.uint32(18).fork()).ldelim();
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
    }
    return writer;
  },
  decode: function decode(input, length) {
    var reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    var end = length === undefined ? reader.len : reader.pos + length;
    var message = createBaseApplicationMenu();
    while (reader.pos < end) {
      var tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.appId = reader.string();
          break;
        case 2:
          message.menuItems.push(exports.MenuItem.decode(reader, reader.uint32()));
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },
  fromJSON: function fromJSON(object) {
    return {
      appId: isSet(object.appId) ? String(object.appId) : "",
      menuItems: Array.isArray(object === null || object === void 0 ? void 0 : object.menuItems) ? object.menuItems.map(function (e) {
        return exports.MenuItem.fromJSON(e);
      }) : []
    };
  },
  toJSON: function toJSON(message) {
    var obj = {};
    message.appId !== undefined && (obj.appId = message.appId);
    if (message.menuItems) {
      obj.menuItems = message.menuItems.map(function (e) {
        return e ? exports.MenuItem.toJSON(e) : undefined;
      });
    } else {
      obj.menuItems = [];
    }
    return obj;
  },
  create: function create(base) {
    return exports.ApplicationMenu.fromPartial(base !== null && base !== void 0 ? base : {});
  },
  fromPartial: function fromPartial(object) {
    var _a, _b;
    var message = createBaseApplicationMenu();
    message.appId = (_a = object.appId) !== null && _a !== void 0 ? _a : "";
    message.menuItems = ((_b = object.menuItems) === null || _b === void 0 ? void 0 : _b.map(function (e) {
      return exports.MenuItem.fromPartial(e);
    })) || [];
    return message;
  }
};
function createBaseDynamicMenu() {
  return {
    menuItems: []
  };
}
exports.DynamicMenu = {
  encode: function encode(message) {
    var writer = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _m0.Writer.create();
    if (message.menuItems !== undefined && message.menuItems.length !== 0) {
      var _iterator4 = _createForOfIteratorHelper(message.menuItems),
        _step4;
      try {
        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
          var v = _step4.value;
          exports.MenuItem.encode(v, writer.uint32(10).fork()).ldelim();
        }
      } catch (err) {
        _iterator4.e(err);
      } finally {
        _iterator4.f();
      }
    }
    return writer;
  },
  decode: function decode(input, length) {
    var reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    var end = length === undefined ? reader.len : reader.pos + length;
    var message = createBaseDynamicMenu();
    while (reader.pos < end) {
      var tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.menuItems.push(exports.MenuItem.decode(reader, reader.uint32()));
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },
  fromJSON: function fromJSON(object) {
    return {
      menuItems: Array.isArray(object === null || object === void 0 ? void 0 : object.menuItems) ? object.menuItems.map(function (e) {
        return exports.MenuItem.fromJSON(e);
      }) : []
    };
  },
  toJSON: function toJSON(message) {
    var obj = {};
    if (message.menuItems) {
      obj.menuItems = message.menuItems.map(function (e) {
        return e ? exports.MenuItem.toJSON(e) : undefined;
      });
    } else {
      obj.menuItems = [];
    }
    return obj;
  },
  create: function create(base) {
    return exports.DynamicMenu.fromPartial(base !== null && base !== void 0 ? base : {});
  },
  fromPartial: function fromPartial(object) {
    var _a;
    var message = createBaseDynamicMenu();
    message.menuItems = ((_a = object.menuItems) === null || _a === void 0 ? void 0 : _a.map(function (e) {
      return exports.MenuItem.fromPartial(e);
    })) || [];
    return message;
  }
};
function isSet(value) {
  return value !== null && value !== undefined;
}